export default __webpack_public_path__ + "images/pages/quiz/categories/mobile_other-69ed554805d760745332f81c435879f6.svg";